import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { type ReactNode, useState } from 'react';

/**
 * TanStack Query 프로바이더.
 *
 * - 기본 stale time을 30초로 설정해 짧은 시간 내 재요청을 줄인다.
 * - 코드 검증 mutation은 재시도하지 않는다(같은 코드를 다시 보내봐야 결과가 같음).
 * - 윈도우 포커스 시 자동 refetch는 기본 켜진 채로 둔다.
 */
export function QueryProvider({ children }: { children: ReactNode }): React.JSX.Element {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            gcTime: 5 * 60_000,
            retry: 1,
          },
          mutations: {
            retry: 0,
          },
        },
      }),
  );

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
